/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Button } from "@aws-amplify/ui-react";

export default function LandingPageFeatureList(props) {
  const { overrides, productsRef, navigateToLogin, ...rest } = props;

  // Halved descriptions
  const featureDescriptionData = [
    { 
      title: 'B2B Analytics', 
      description: 'Gain insights into corporate buyer identity and procurement trends to optimize your B2B operations on Amazon.' 
    },
    { 
      title: 'Sales and Traffic Reporting', 
      description: (
        <>
          Track customer demand, conversion rates, and sales trends with actionable insights and intuitive dashboards. Optimize product selection with{' '}
          <a 
            href="https://business.amazon.com/en/discover-more/blog/sellers-customer-base" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ color: '#007B8F', textDecoration: 'underline' }}
          >
            higher average order value sales
          </a>.
        </>
      )
    },
    { 
      title: 'AI Driven Forecasting', 
      description: 'Predict future revenue and demand using historical data to manage inventory effectively and reduce risks. Aitium helps you make data-driven decisions about your available inventory.' 
    },
    { 
      title: 'Amazon Business Intelligence', 
      description: 'Growing twice as fast as retail sales, poised to grow from 6.6% of worldwide store sales to 12.6% by 2026. Cut returns and ad spending by 50% or more.' 
    },
  ];

  const logoStyle = {
    height: '40px'
  };

  const Card = ({ title, description }) => {
    const cardStyle = {
      display: 'block',
      alignItems: 'center',
      padding: '40px',
      margin: '10px',
      borderRadius: '5px',
      backgroundColor: 'white',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      width: '35%'
    };

    const iconStyle = {
      height: '40px',
      width: '40px',
      backgroundColor: '#E0F7FA',
      borderRadius: '50%',
      display: 'block',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '20px',
      marginBottom: '15px'
    };

    const contentStyle = {
      textAlign: 'left'
    };

    const titleStyle = {
      fontSize: '1.4em',
      fontWeight: 'bold',
      marginBottom: '10px'
    };

    const descriptionStyle = {
      fontSize: '1em',
      color: '#555'
    };

    return (
      <div style={cardStyle}>
        <div style={iconStyle}>
          <img src="feature-check-icon.png" alt="" style={logoStyle} />
        </div>
        <div style={contentStyle}>
          <div style={titleStyle}>{title}</div>
          <div style={descriptionStyle}>{description}</div>
        </div>
      </div>
    );
  };

  const featuresListContainer = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingTop: '50px',
    paddingBottom: '50px',
    backgroundColor: '#F8F8F8'
  };

  const freeTrialButtonStyle = {
    marginTop: '20px', // Added spacing above the button
    marginBottom: '20px',
    padding: '10px 20px',
    backgroundColor: '#007B8F',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '1.2em'
  };

  return (
    <Flex
      style={{ flexDirection: 'column', alignItems: 'center' }}
      ref={productsRef}
      {...getOverrideProps(overrides, "FeaturesList")}
      {...rest}
    >
      {/* Free Trial Button */}
      <Button
        style={freeTrialButtonStyle}
        onClick={navigateToLogin}
      >
        Start Your Free 7-Day Trial – No Credit Card Required
      </Button>

      {/* Features List */}
      <Flex style={featuresListContainer}>
        {featureDescriptionData.map((card, index) => (
          <Card 
            key={index} 
            title={card.title} 
            description={card.description} 
            {...getOverrideProps(overrides, `Card-${index}`)} 
          />
        ))}
      </Flex>
    </Flex>
  );
}